import { Injectable } from '@angular/core';
import { ConsumptionFilter } from '@app/shared/models/visualization/consumption';
import { BehaviorSubject } from 'rxjs';
import { ConsumptionStoreService } from './consumption-store.service';
import { ChartTypes } from '@app/shared/enums';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class StundenwerteService {
  public chartType$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public chartTypes: ChartTypes[] = [];
  public dateFilter!: ConsumptionFilter;
  public footerLabel = '';
  public pagination!: {
    enabled: boolean;
    hasPrevious: boolean;
    hasNext: boolean;
  };

  constructor(public consumptionStoreService: ConsumptionStoreService) {}

  public init(): void {
    this.pagination = { enabled: true, hasNext: false, hasPrevious: true };
    this.consumptionStoreService.consumptionFilter$.subscribe((filter: ConsumptionFilter) => (this.dateFilter = filter));
    this.chartTypes = [ChartTypes.bar, ChartTypes.line];
    this.chartType$.next(ChartTypes.line);
  }

  public next(): void {
    this.dateFilter.date = moment(this.dateFilter.date).add(1, 'day').toDate();
    this.setPagination();
  }

  public previous(): void {
    this.dateFilter.date = moment(this.dateFilter.date).add(-1, 'day').toDate();
    this.setPagination();
  }

  public setPagination(): void {
    this.pagination.hasNext = (this.dateFilter.date as Date) < (this.dateFilter.endDate as Date);
    this.pagination.hasPrevious = (this.dateFilter.date as Date) > (this.dateFilter.startDate as Date);
  }

  public getTimeInterval(): string[] {
    const date = new Date();

    let start = moment(new Date(date.getFullYear(), date.getMonth(), date.getDate()))
      .add(1, 'hours')
      .toDate();
    const end = moment(start).add(1, 'day').toDate();

    const slices: string[] = [];

    while (end > start) {
      slices.push(`${String(moment(start).hours() === 0 ? 24 : moment(start).hours()).padStart(2, '0')}:${String(moment(start).minutes()).padStart(2, '0')}`);
      start = new Date(start.getTime() + 60 * 60 * 1000);
    }

    return slices;
  }
}
